import { render, staticRenderFns } from "./GameHubPage.vue?vue&type=template&id=0a659540&scoped=true"
import script from "./GameHubPage.vue?vue&type=script&lang=js"
export * from "./GameHubPage.vue?vue&type=script&lang=js"
import style0 from "./GameHubPage.vue?vue&type=style&index=0&id=0a659540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a659540",
  null
  
)

export default component.exports